const zhiyanReportUrl = `${location.protocol}//ap-hongkong-fit.log.zhiyan.tencent-cloud.net/collect`;
const zhiyanTopic = 'sdk-bg3c6bcea5dd836b';

/**
 * 通过 xhr 上报
 * @param {*} data 
 */
function reportZhiyanByXHR(data) {
  const xhr = new XMLHttpRequest();
  xhr.open('POST', zhiyanReportUrl);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.send(data);
}


// 上报智研日志汇
export function reportZhiyan(params) {
  const data = JSON.stringify(getZhiyanReportParams(params));
  // 通过 sendBeacon 上报
  if (navigator.sendBeacon) {
    const isSendBeaconSuc = navigator.sendBeacon(zhiyanReportUrl, data)
    if (isSendBeaconSuc) return;
  }
  // 通过 xhr 上报
  reportZhiyanByXHR(data);
}

// 格式化用户手机本地时间
function formatClientTime(timestamp) {
  try {
    const date = new Date(timestamp);

    // 使用 Intl.DateTimeFormat 将日期对象转换为带有时区的字符串
    const formattedDate = new Intl.DateTimeFormat('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short',
    }).format(date);

    return formattedDate;
  } catch (error) {
    console.log('reportZhiyan formatClientTime error: ', error);
    return timestamp;
  }
}

/**
 * 智研上报参数
 * 字段说明：https://iwiki.woa.com/p/4009916972
 * @param {*} params
 * @returns
 */
function getZhiyanReportParams(params = {}) {
  const { client_time, channel, key, errCode } = params;
  const formatedClientTime = formatClientTime(client_time);
  return {
    topic: zhiyanTopic,
    data: [
      {
        // 智研默认上报时间（在数据处理时算子会重置为服务器当前时间）
        timestamp: client_time,
        message: `${channel}_${key}_${errCode}`,
        fields: {
          ...params,
          // 补充 ua(目前智研不支持默认上报，先手动上报)
          ua: window.navigator.userAgent,
          // 补充 http_referer
          // http_referer: document.referrer,
          http_referer: window.location.href,
          // 用户手机本地时间
          client_time_str: formatedClientTime,
        },
      },
    ],
  };
}
